<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        :title="`Histórico de baixa (${item.vacinaNome})`"
        large
        ref="Modal"
    >

        <rkm-table
            :fields="fields"
            :items="data"
            ref="DataTableHistorico"
            search-by="dataSaida"
        >
            <template v-slot:cell(dataSaida)='row'>
                {{ row.value | formatDate }}
            </template>

            <template v-slot:cell(acoes)="row">
                <rkm-button
                    color="primary"
                    @click.stop="print(row)"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-modal>
</template>

<script>
// Mixins.
import { error, file, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Filters
import formats from '@/filters/formats'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {
            return [
                { key: 'dataSaida', label: 'Data', name: 'dataSaida', searchable: true, sortable: true },
                { key: 'motivo', label: 'Motivo', name: 'motivo', searchable: true, sortable: true },
                { key: 'quantidade', label: 'Quantidade', name: 'quantidade', searchable: true, sortable: true },
                { key: 'usuario', label: 'Usuário', name: 'usuario', searchable: true, sortable: true },
                { key: 'acoes', label: 'Ações', name: 'acoes', searchable: false, sortable: false },
            ]
        }
    },
    created() {
        this.repositories = {
            baixa: this.getConectaSusRepository('imunizacao.baixa'),
            impressao: this.getConectaSusRepository('impressao.imunizacao'),
        }
    },
    data: () => ({
        item: {},
        data: []
    }),
    filters: {
        formatDate: formats.formatDate,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.item = item

            this.load();

            this.$refs.Modal.show()
        },
        load() {
            this.setLoading()

            const request = {
                salaVacinacaoId: this.item.salaVacinacaoId,
                vacinaId: this.item.vacinaId,
            }

            this.repositories.baixa.historico(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data = response.data
                })
                .catch(this.handleError)
                .finally(() => {
                    this.unsetLoading();
                })

        },
        print({item}) {
            this.setLoading()

            return this.repositories.impressao.baixa(item.id)
                .then(response => {
                    this.openFile(response.data, response.headers['content-type'])
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ error, file, repository, stringCase ],
}
</script>
